import type { OutreachDraft } from '../types';

/**
 * Builds a `mailto:` URL from an outreach draft so Danielle can send it from her
 * own mail client in Phase 0 (no Resend yet). The body is the editable
 * Markdown verbatim. Returns null when there's no recipient email (a blocked
 * draft) so the caller can hide the button.
 */
export function buildDraftMailto(d: OutreachDraft): string | null {
  if (!d.recipientEmail) return null;
  return (
    `mailto:${encodeURIComponent(d.recipientEmail)}` +
    `?subject=${encodeURIComponent(d.subject)}` +
    `&body=${encodeURIComponent(d.bodyMd)}`
  );
}
